import { rootApi } from "../../api/rootApi";

export const productDateRankRulesApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchProductDateRankRules: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/product-date-rank-rules?limit=${params.limit}&offset=${params.offset}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    // ── 2) Export Report Endpoint──
    exportProductDateRankRules: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/borosil/product-date-rank-rules-export`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useFetchProductDateRankRulesMutation,
  useExportProductDateRankRulesMutation,
} = productDateRankRulesApi;
